import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginLayoutComponent } from './pages/login-layout/login-layout.component';
import { MainLayoutComponent } from './pages/main-layout/main-layout.component';
const subRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
    },
    {
        path: 'home',
        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
    },
    {
        path: 'configuration',
        loadChildren: () => import('./modules/configuration/configuration.module').then((m) => m.ConfigurationModule),
    },
    {
        path: 'external-link',
        loadChildren: () => import('./modules/external-link/external-link.module').then((m) => m.ExternalLinkModule),
    },
    {
        path: 'operation',
        loadChildren: () => import('./modules/operations-management/operations-management.module').then((m) => m.OperationsManagementModule),
    },
];

const loginRoutes: Routes = [
    {
        path: '',
        loadChildren: () => import('./modules/Login/login.module').then(m => m.LoginModule)
    }
];


const routes: Routes = [
    {
        path: 'login',
        children: loginRoutes,
        component: LoginLayoutComponent
    },
    {
        path: '',
        children: subRoutes,
        component: MainLayoutComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule {

}
